module["exports"] = [
  "Gruppen",
  "AS",
  "ASA",
  "BA",
  "RFH",
  "og Sønner"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/nb_NO/company/suffix.js
// module id = 1763
// module chunks = 0